module.exports = __webpack_public_path__ + "img/IMG_9219.2d82fb0f.jpg";